module.exports = __webpack_public_path__ + "static/media/back-svg-black.21f590ff.svg";